import React from "react";
import { Typography as SenderName } from "@mui/material";
import { SenderCheckbox } from "../GroupHeader.style";
import { SenderType } from "./GroupMessageSearchInput";

type GroupMessageSearchOptionProps = {
  userDetail: SenderType;
  selected: boolean;
} & React.HTMLAttributes<HTMLLIElement>;

const GroupMessageSearchOption = ({
  userDetail,
  selected,
  ...props
}: GroupMessageSearchOptionProps) => {
  return (
    <li {...props} data-testid="MembersCheckbox" key={userDetail.id}>
      <SenderCheckbox checked={selected} />
      <SenderName data-testid="MemberFilter" variant={"body1"}>
        {userDetail.name}
      </SenderName>
    </li>
  );
};

export default GroupMessageSearchOption;
